import { render, staticRenderFns } from "./Confimation.vue?vue&type=template&id=b26331e4&"
import script from "./Confimation.vue?vue&type=script&lang=js&"
export * from "./Confimation.vue?vue&type=script&lang=js&"
import style0 from "./Confimation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports